import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/fonts/font.css";
import axios from "axios";
import Vant from "vant";
import { Toast } from "vant";
import "vant/lib/index.css";
// import "./components/SP.js";
import "./utils/initRem.js";
import MetaInfo from "vue-meta-info";
// 引入 Vconsole
import Vconsole from "vconsole";

// 所有环境均使用
// new Vconsole();

import {
  setMoment,
  add_comma_toThousands,
  convertDateToTimestamp,
  validateEmail,
  compressAndUpload,
  getBase64Image,
} from "./utils/funcJS";
import store from "@/store/index.js";

Vue.use(ElementUI);
Vue.use(MetaInfo);
Vue.use(Vant);

Vue.prototype.$setMoment = setMoment;
Vue.prototype.$setNum = add_comma_toThousands;
Vue.prototype.$setTimeStr = convertDateToTimestamp;
Vue.prototype.$validateEmail = validateEmail;
Vue.prototype.$Toast = Toast;

// 压缩图片方法
Vue.prototype.$compressImg = compressAndUpload;
// 图片转换64字符串
Vue.prototype.$setBase64Img = getBase64Image;

const whiteList = [
  "home",
  "historyList",
  "Inicio",
  "Sobre",
  "Ayuda",
  "Aviso",
  "Uso",
  "fraude",
  "libro",
];

// 注册离线服务
const registerServiceWorker = async () => {
  if ("serviceWorker" in navigator) {
    try {
      const registration = await navigator.serviceWorker.register(
        "./service-worker.js"
      );
      if (registration.installing) {
        console.log("正在安装 Service worker");
      } else if (registration.waiting) {
        console.log("已安装 Service worker installed");
      } else if (registration.active) {
        console.log("激活 Service worker");
      }
    } catch (error) {
      console.error(`注册失败：${error}`);
    }
  }
};

window.addEventListener("load", () => {
  registerServiceWorker();
});

router.beforeEach(async (to, from, next) => {
  if (whiteList.indexOf(to.name) > -1) {
    next();
  } else {
    const statusInfo = JSON.parse(localStorage.getItem("userInfo"));
    if (
      (statusInfo.order_status == 0 ||
        statusInfo.order_status == 8 ||
        statusInfo.order_status == 3 ||
        statusInfo.order_status == 10) &&
      localStorage.getItem("token")
    ) {
      next();
    } else if (
      localStorage.getItem("token") &&
      statusInfo.order_status !== 0 &&
      statusInfo.order_status !== 8 &&
      statusInfo.order_status !== 10
    ) {
      next("/h5Page/home");
    } else if (!localStorage.getItem("token") && to.path !== "/h5Page/home") {
      next("/h5Page/home");
    }
  }
});

axios
  .get(
    // "http://114.116.221.105:9090/gateway/ApiService/api/v3/customer/service/info/H5?source=CrediSol"
    "https://api.credisol.pe/gateway/ApiService/api/v3/customer/service/info/H5?source=CrediSol"
  )
  .then(({ data }) => {
    localStorage.setItem("customerData", JSON.stringify(data.data));
  });

Vue.config.productionTip = false;

export default new Vue({
  render: (h) => h(App),
  router,
  store,
}).$mount("#app");
